const accordions = document.querySelectorAll('.title-with-accordion');

accordions.forEach((accordion) => {
  const elements = accordion.querySelectorAll('.accordion-element');
  const buttons = accordion.querySelectorAll('.accordion-element__button');
  const contents = accordion.querySelectorAll('.accordion-element__content');
  const toggles = accordion.querySelectorAll('.accordion-element__toggle');

  elements.forEach((element) => {
    const button = element.querySelector('.accordion-element__button');
    const content = element.querySelector('.accordion-element__content');
    const toggle = element.querySelector('.accordion-element__toggle');

    button.addEventListener('click', () => {
      buttons.forEach((button) => {
        button.classList.remove('accordion-element__button--active');
      });
      button.classList.add('accordion-element__button--active');

      contents.forEach((content) => {
        content.classList.remove('accordion-element__content--active');
      });
      content.classList.add('accordion-element__content--active');

      toggles.forEach((toggle) => {
        toggle.classList.remove('accordion-element__toggle--active');
      });
      toggle.classList.add('accordion-element__toggle--active');
    });
  });
});
